import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { pages: Object, notice: String, unavailable: String }

  connect() {
    this.submitHandler = (event) => {
      const method = (event.target.method || "get").toLowerCase()
      if (method === "get") {
        const action = new URL(event.target.action || window.location.href, window.location.href)
        const destination = this.previewDestination(action.pathname)
        if (destination) {
          event.preventDefault()
          const params = new URLSearchParams(new FormData(event.target))
          window.location.assign(`${destination}${params.size ? `?${params}` : ""}`)
          return
        }
      }
      event.preventDefault()
      event.stopImmediatePropagation()
      this.showNotice(method === "get" ? this.unavailableMessage : this.noticeMessage)
    }
    this.clickHandler = (event) => {
      const link = event.target.closest("a[href]")
      if (!link || link.target === "_blank" || link.hasAttribute("download")) return
      const url = new URL(link.href, window.location.href)
      if (url.origin !== window.location.origin || [ "mailto:", "tel:" ].includes(url.protocol)) return
      if (url.hash && url.pathname === window.location.pathname) return

      event.preventDefault()
      const destination = this.previewDestination(url.pathname)
      if (destination) window.location.assign(`${destination}${url.search}${url.hash}`)
      else this.showNotice(this.unavailableMessage)
    }
    this.element.addEventListener("submit", this.submitHandler, true)
    this.element.addEventListener("click", this.clickHandler, true)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.submitHandler, true)
    this.element.removeEventListener("click", this.clickHandler, true)
    clearTimeout(this.noticeTimer)
  }

  previewDestination(pathname) {
    if (this.pagesValue[pathname]) return this.pagesValue[pathname]
    if (pathname.startsWith("/products/") && this.pagesValue["/products/:product"]) {
      return this.pagesValue["/products/:product"]
    }
  }

  showNotice(message) {
    let notice = document.getElementById("draft-preview-notice")
    if (!notice) {
      notice = document.createElement("div")
      notice.id = "draft-preview-notice"
      notice.className = "fixed left-1/2 top-4 z-[9999] -translate-x-1/2 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white shadow-xl"
      document.body.append(notice)
    }
    notice.textContent = message
    clearTimeout(this.noticeTimer)
    this.noticeTimer = setTimeout(() => notice.remove(), 2600)
  }

  get noticeMessage() {
    return this.hasNoticeValue ? this.noticeValue : "This is a draft preview. Storefront submissions are disabled."
  }

  get unavailableMessage() {
    return this.hasUnavailableValue ? this.unavailableValue : "This destination is not available in the draft preview."
  }
}
